import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const projectsApi = createApi({
  reducerPath: "projectsApi",
  baseQuery: customFetchBase({ url: "projects" }),
  endpoints: (builder) => ({
    getProjects: builder.query({
      query: ({ page = 1, search } = {}) => {
        let url = `?no_of_docs_each_page=25&page=${page}`;
        if (search) url += `&q=${search}`;
        return {
          url,
          method: "GET",
        };
      },
    }),
    createProject: builder.mutation({
      query: (data) => ({
        method: "POST",
        body: data,
      }),
    }),
    updateProject: builder.mutation({
      query: (data) => ({
        method: "PUT",
        body: data,
      }),
    }),
    deleteProject: builder.mutation({
      query: (code) => ({
        url: `?code=${code}`,
        method: "DELETE",
      }),
    }),
  }),
});
export const {
  useGetProjectsQuery,
  useDeleteProjectMutation,
  useUpdateProjectMutation,
  useCreateProjectMutation,
} = projectsApi;
